import Flickity from "flickity-as-nav-for";
require("flickity-imagesloaded");
require("flickity-fade");

const Slider = () => {
  //Slider default
  let sliderDefault = document.querySelectorAll(".slider-default");
  if (sliderDefault)
    sliderDefault.forEach((slider) => {
      let flkty;
      let dataGroup = slider.dataset.group;
      let dataDots = slider.dataset.dots;
      let dataNextPrev = slider.dataset.nextprev;
      let dataAdaptiveHeight = slider.dataset.adaptiveheight;
      let dataCenter = slider.dataset.center;
      let dataAutoplay = slider.dataset.autoplay;
      let dataWrapAround = slider.dataset.wraparound;
      let dataContain = slider.dataset.contain;
      let dataWatchCSS = slider.dataset.watchcss;
      let dataInitialIndex = slider.dataset.initialindex;

      flkty = new Flickity(slider, {
        cellAlign: dataCenter ? dataCenter : "left",
        imagesLoaded: true,
        prevNextButtons: dataNextPrev !== undefined,
        groupCells: dataGroup ? dataGroup : false,
        pageDots: dataDots !== undefined,
        adaptiveHeight: dataAdaptiveHeight ? dataAdaptiveHeight : false,
        autoPlay: dataAutoplay !== undefined,
        wrapAround: dataWrapAround !== undefined,
        contain: dataContain !== undefined,
        initialIndex: dataInitialIndex ? Number(dataInitialIndex) : 0,
        watchCSS: dataWatchCSS ? dataWatchCSS : false,
      });

      flkty.on('dragStart', () => flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none") );
      flkty.on('dragEnd', () => flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all") );

      // elements
      const sliderNav =
        slider.parentElement.querySelector(".slider-pagination");

      if (sliderNav) {
        let cellButtonGroup = sliderNav.querySelector(".button-group--cells");
        let cellButtons = cellButtonGroup.querySelectorAll(".button");

        flkty.on("select", () => {
          cellButtons.forEach((button, index) => {
            button.classList.remove("is-selected");

            if (index == flkty.selectedIndex)
              button.classList.add("is-selected");
          });
        });

        cellButtons.forEach((button, index) => {
          button.addEventListener("click", function () {
            flkty.select(index);
          });
        });

        let btnPrev = sliderNav.querySelector(".button--previous");
        let btnNext = sliderNav.querySelector(".button--next");

        btnPrev.addEventListener("click", function () {
          flkty.previous();
        });

        btnNext.addEventListener("click", function () {
          flkty.next();
        });
      }
    });
};
export default Slider;
